import { missionChangeEntries } from "../utils/missionChange"
import React, { useState, useEffect, useCallback, useRef, useMemo } from "react"
import Skeleton from "./Skeleton"
import { utcToIsoString } from "../utils/dates"
import { getMissions, getMissionsLiteIds } from "../services/api/v2/mission"
import { getActionItems } from "../services/api/v2/actionItem"
import { paginateAll, paginateChunked } from "../services/api/utils"
import uniqBy from "lodash/uniqBy"
import { PiPushPinDuotone, PiPushPinFill } from "react-icons/pi"
import { Scrollbars } from "react-custom-scrollbars"
import SearchDropDown from "./SearchDropDown"
import BarLoader from "react-spinners/BarLoader"
import { getNextFn } from "../services/api/utils"
import { toZonedTime } from "date-fns-tz"

import { addDays, addWeeks, subMonths, addMonths, startOfWeek, endOfWeek, startOfDay, endOfDay } from "date-fns"

import {
    getPersonName,
    getRefId,
    sortAlpha,
    getMissionStatus,
    getMissionStatusCls,
    makeHash,
    makeRefHash,
    saveFilters,
    getFilters,
} from "../utils/utils"
import { findAiEndDate, getTimeUtc, formatX } from "../utils/dates"
import { isOverdue, getAiCode } from "../utils/actionItem"

import CheckBoxes from "../comp/CheckBoxes"

import { MissionSearch } from "./DropDowns"

import Hive from "./Hive"

import numeral from "numeral"

import uniq from "lodash/uniq"

import cx from "classnames"
import { addParam } from "./History"
import "ag-grid-enterprise"
import { AgGridReact } from "ag-grid-react"
import "ag-grid-community/styles/ag-grid.css"
import formatDistanceToNowStrict from "date-fns/formatDistanceToNowStrict"
import "ag-grid-community/styles/ag-theme-alpine.css"

import "../scss/DnaAgGrid.scss"
import "./TaskMaster.scss"
import { getMissionBasicDetails } from "../utils/mission"

const statusArray = [
    { label: "Overdue", id: "overdue" },
    { label: "Blocked", id: "blocked" },
    { label: "Due today", id: "due-today" },
    { label: "Due tomorrow", id: "due-tomorrow" },
    { label: "Due this week", id: "due-this-week" },
    { label: "Due next week", id: "due-next-week" },
    { label: "CRs awaiting approval", id: "cr-open" },
    { label: "Approved CRs", id: "cr-approved" },
    { label: "Sign-offs awaiting approval", id: "so-open" },
    { label: "Sign-offs approved", id: "so-approved" },
    { label: "In progress", id: "in-progress" },
    { label: "Not being worked on", id: "not-planned" },
    { label: "Complete", id: "done" },
]
const missionStatusArray = [
    {
        label: "Active",
        id: "active",
    },
    {
        label: "Complete 🍾",
        id: "completed",
    },
    {
        label: "Cancelled",
        id: "cancelled",
    },
    {
        label: "On-hold",
        id: "on-hold",
    },
]

const aiSelect = [
    "_id",
    "title",
    "code",
    "missionId",
    "actionId",
    "missionPlanId",
    "people",
    "startDate",
    "endDate",
    "week",
    "percentComplete",
    "metaType",
    "pinType",
    "status",
    "amount",
    "billRate",
    "pinType",
    "col",
    "+signOffs",
    "+approvals",
    "+checklist",
    "+seen",
    "pinned",
    "createdAt",
]
const TaskMaster = ({ app, stateChange, recommendations, setContext, fields, taskMasterRef }) => {
    const sf = useMemo(() => {
        return getFilters("my-task-filters") || {}
    }, [])

    const to = useRef()
    const hasMore = useRef(true)
    const rowBufferRef = useRef([])
    const nextIndexRef = useRef()
    const loadingRef = useRef()
    const [loading, setLoading] = useState(true)
    const missionRef = useRef([])
    const [search, setSearch] = useState()
    const searchRef = useRef()

    useEffect(() => {
        searchRef.current = search
    }, [search])

    // null until the count is back - render nothing so neither the grid nor the welcome flashes
    const [hasMissions, setHasMissions] = useState(null)

    const [filters, setFilters] = useState({
        ...sf,
        personRefId: sf.personRefId || app.state.person._id,
    })

    useEffect(() => {
        const check = async () => {
            try {
                const c = await getMissionsLiteIds({
                    exists: ["isTemplate:false", "isModel:false", "kickedOff:true"],
                    count: true,
                    limit: 1,
                    startDate: `lte ${utcToIsoString(addMonths(new Date(), 3))}`,
                    endDate: `gte ${utcToIsoString(subMonths(new Date(), 3))}`,
                })

                setHasMissions(!!c?.count)
            } catch (e) {
                // Count failed - fall back to the grid rather than leaving the area blank
                setHasMissions(true)
            }
        }

        check()
    }, [])

    useEffect(() => {
        saveFilters("my-task-filters", filters)
    }, [filters])

    const gridRef = useRef()
    const orgRef = useRef(makeHash(app.state.orgs))

    useEffect(() => {
        orgRef.current = makeHash(app.state.orgs)
    }, [app.state.orgs])

    const [totalTasks, setTotalTasks] = useState(0)

    const columnDefs = useMemo(
        () => [
            {
                field: "pinned",
                headerName: "",
                maxWidth: 30,
                suppressMovable: true,
                cellStyle: { paddingRight: 0, paddingLeft: 3, cursor: "pointer" },
                cellRenderer: (params) => {
                    if (params.data?.pinnedMessage) {
                        return <></>
                    }

                    if (params.data?._id && app.state.person?.appUiState?.pinnedTasks?.includes(params.data._id)) {
                        return (
                            <div className="dna-under-con ">
                                <PiPushPinFill color="orange" style={{ transform: "translateY(0px)", fontSize: 13 }} />
                            </div>
                        )
                    } else {
                        return (
                            <div className="dna-under-con ">
                                <PiPushPinDuotone
                                    style={{ opacity: 0.3, transform: "translateY(0px)", fontSize: 13 }}
                                />
                            </div>
                        )
                    }
                },
            },
            {
                field: "_id",
                headerName: "",
                flex: 1,
                suppressMovable: true,
                cellRenderer: (params) => (params.data ? <TaskCell {...params} /> : <></>),
                cellRendererParams: {
                    orgRef,
                    app,
                    setContext,
                    missionRef,
                    rowBufferRef,
                },
            },
        ],
        [app.state.orgs],
    )

    const loadData = async () => {
        if (searchRef.current?.taskCode) {
            const tc = await getActionItems({ count: true, code: search?.taskCode, select: aiSelect })

            setTotalTasks(tc.count)
            return {
                pinned: [],
                resp: tc,
            }
        }

        let statusFilters = {
            // /sortBy: "visitDate",
        }

        if (filters.status) {
            if (filters.status === "blocked" || filters.status === "done" || filters.status === "open") {
                statusFilters.status = [filters.status]
            } else {
                if (filters.status === "due-this-week") {
                    statusFilters.endDate = `gte ${utcToIsoString(
                        startOfWeek(new Date(), { weekStartsOn: 1 }),
                    )} and lte ${utcToIsoString(endOfWeek(new Date(), { weekStartsOn: 1 }))}`
                } else if (filters.status === "due-next-week") {
                    statusFilters.endDate = `gte ${utcToIsoString(
                        startOfWeek(addWeeks(new Date(), 1), { weekStartsOn: 1 }),
                    )} and lte ${utcToIsoString(endOfWeek(addWeeks(new Date(), 1), { weekStartsOn: 1 }))}`
                } else if (filters.status === "overdue") {
                    statusFilters.status = "open"
                    statusFilters.endDate = `lte ${utcToIsoString(new Date())}`
                    statusFilters.sortBy = "endDate"
                } else if (filters.status === "due-today") {
                    statusFilters.status = "open"
                    statusFilters.endDate = `gte ${utcToIsoString(
                        startOfDay(new Date(), { weekStartsOn: 1 }),
                    )} and lte ${utcToIsoString(endOfDay(new Date(), { weekStartsOn: 1 }))}`
                } else if (filters.status === "due-tomorrow") {
                    statusFilters.status = "open"
                    statusFilters.endDate = `gte ${utcToIsoString(
                        startOfDay(addDays(new Date(), 1), { weekStartsOn: 1 }),
                    )} and lte ${utcToIsoString(endOfDay(addDays(new Date(), 1), { weekStartsOn: 1 }))}`
                } else if (filters.status === "cr-open") {
                    statusFilters.hasChangeRequestOpen = true
                } else if (filters.status === "cr-approved") {
                    statusFilters.hasChangeRequestApproved = true
                } else if (filters.status === "so-open") {
                    statusFilters.hasSignOffOpen = true
                } else if (filters.status === "so-approved") {
                    statusFilters.hasSignOffApproved = true
                }
            }
        }

        if (filters.forceTaskStatus) {
            statusFilters.status = [filters.forceTaskStatus]
        }

        const pinnedA = []

        if (filters.personRefId === "mine-pinned") {
            if (!app.state.person?.appUiState?.pinnedTasks?.length) {
                setTotalTasks(0)
                return {
                    pinned: [],
                    resp: { value: [] },
                }
            }
            const pa = await getActionItems({
                count: true,
                id: app.state.person?.appUiState?.pinnedTasks,
                select: aiSelect,
                limit: 50,
            })

            // ok

            pinnedA.push(...(pa.value || []))

            if (filters.personRefId === "mine-pinned") {
                setTotalTasks(pa?.count)

                return {
                    pinned: pinnedA,
                    resp: pa,
                }
            }
        }

        const ga = await getActionItems({
            "project.participating": Boolean(filters.personRefId === app.state.person._id),
            "project.exists": ["isTemplate:false", "isModel:false"],
            "project.department": filters.departmentId,
            "project.id": filters.missionId,
            "project.projectStatus": [filters.missionStatus],
            "project.startDate": filters.missionId ? undefined : `lte ${utcToIsoString(addMonths(new Date(), 3))}`,
            "project.endDate": filters.missionId ? undefined : `gte ${utcToIsoString(subMonths(new Date(), 3))}`,
            count: true,
            limit: 50,
            person: filters.personRefId ? [filters.personRefId] : undefined,
            ...statusFilters,
            search: searchRef.current,
            sortBy: statusFilters.sortBy,
            select: aiSelect,
        })

        setTotalTasks(ga?.count)

        return {
            pinned: pinnedA,
            resp: ga,
        }
    }

    const getData = async () => {
        let newRows = []

        setLoading(true)

        if (nextIndexRef.current) {
            const rf = await getNextFn(nextIndexRef.current)()
            nextIndexRef.current = rf?.nextLink
            hasMore.current = !!rf?.hasNext?.()
            newRows = rf?.value || []
        } else {
            //load
            const rfB = await loadData()

            if (rfB.pinned?.length) newRows.push(...rfB.pinned)

            nextIndexRef.current = rfB?.resp?.nextLink
            hasMore.current = !!rfB?.resp?.hasNext?.()
            newRows.push(...(rfB?.resp?.value || []))
            newRows = uniqBy(newRows, "_id")
        }

        loadingRef.current = false
        setLoading(false)

        rowBufferRef.current = rowBufferRef.current.concat(newRows)

        return newRows
    }

    const resetInfiniteGrid = useCallback(() => {
        setTotalTasks(0)
        // 1️⃣ Clear your accumulated data
        rowBufferRef.current = []

        // 2️⃣ Reset cursor + flags
        nextIndexRef.current = null
        hasMore.current = true

        // 3️⃣ Tell AG Grid to forget everything
        gridRef.current.api.purgeInfiniteCache()
    }, [])

    useEffect(() => {
        if (app.state.home && gridRef.current?.api) {
            document.getElementById("23oi4u90").value = ""
            document.getElementById("23oi4u89").value = ""
            resetInfiniteGrid()
        }
    }, [app.state.home, filters])

    const dataSource = useMemo(
        () => ({
            getRows: async (params) => {
                try {
                    // Load enough rows to satisfy the request
                    while (rowBufferRef.current.length < params.endRow && hasMore.current) {
                        await getData()
                    }

                    const rowsThisPage = rowBufferRef.current.slice(params.startRow, params.endRow)

                    if (!hasMore.current) {
                        params.successCallback(rowsThisPage, rowBufferRef.current.length)
                    } else {
                        params.successCallback(rowsThisPage, -1)
                    }
                } catch (e) {
                    params.failCallback()
                }
            },
        }),
        [filters, search],
    )

    const peopleIds = useMemo(() => app.state.orgs.flatMap((o) => (o.people || []).map((p) => p._id)), [app.state.orgs])

    const people = useMemo(() => {
        return app.state.orgs.flatMap((o) => o.people || [])
    }, [peopleIds])

    const peopleHash = useMemo(() => {
        return makeRefHash(people)
    }, [people])

    //Grid
    const getRowId = useCallback((params) => {
        return params?.data?._id
    }, [])

    const pinnedTopRowData = useMemo(() => {
        if (recommendations.find((r) => r.isOrgInvite || r.isMissionInvite || r.isAdminTask)) {
            return [
                {
                    title: " ",
                    pinned: true,
                    pinnedMessage: true,
                },
            ]
        } else {
            return null
        }
    }, [recommendations])

    const updateFilters = (change) => {
        const personId = app?.state?.person?._id

        const currentAppUiState = app?.state?.person?.appUiState ?? {}
        const currentHomeState = currentAppUiState.homeState ?? {}

        let parsedFilters = {}

        try {
            if (typeof currentHomeState.filters === "string") {
                parsedFilters = JSON.parse(currentHomeState.filters)
            } else if (typeof currentHomeState.filters === "object" && currentHomeState.filters !== null) {
                parsedFilters = currentHomeState.filters
            }
        } catch {
            parsedFilters = {}
        }

        const baseFilters = {
            ...(personId ? { personRefId: personId } : {}),
            ...parsedFilters,
        }

        const newFilters = {
            ...baseFilters,
            ...change,
        }

        setFilters(newFilters)

        app?.personUpdate?.({
            appUiState: {
                ...currentAppUiState,
                homeState: {
                    ...currentHomeState,
                    filters: JSON.stringify(newFilters),
                },
            },
        })
    }

    const defaultColDef = {
        suppressMenu: true,
        flex: 1,
        cellClass: (params) => {
            return params.data?.ai?.status === "done" ? "x-tm-done" : undefined
        },
    }

    const onCellClicked = useCallback((params) => {
        if (params.data?.pinnedMessage) {
            setContext("workAI")
            return
        }
        if (!params.data) {
            return
        }
        if (params.colDef.field === "pinned" && params.data) {
            const currentState = app.state.person?.appUiState || {}

            let pinnedTasks = [...(currentState.pinnedTasks || [])]

            const index = pinnedTasks.indexOf(params.data._id)

            if (index !== -1) {
                // Exists → remove it
                pinnedTasks.splice(index, 1)
            } else {
                // Doesn't exist → add to end
                pinnedTasks.push(params.data._id)

                // Enforce max 30
                if (pinnedTasks.length > 50) {
                    pinnedTasks = pinnedTasks.slice(-50)
                }
            }

            app.personUpdate({
                appUiState: {
                    ...currentState,
                    pinnedTasks,
                },
            })
        } else if (params.colDef.field === "mission") {
            addParam("mission", params.data.missionId)
        } else {
            app.showActionItemDetails(params.data)
        }
    }, [])

    if (hasMissions === null) {
        return <div className="x-task-master" />
    }

    if (!hasMissions) {
        return (
            <div className="x-task-master">
                <div className="x-tm-intro">
                    <h3 style={{ marginLeft: 0 }}>
                        Welcome <span className="light-span">young master</span>
                    </h3>

                    <p style={{ maxWidth: 420 }}>
                        When you create or join projects and begin working on tasks they will appear here for you to
                        command and control.
                    </p>

                    <p className="w-400">
                        For now, please start your mission and begin by adding tasks to your prject plan. (top left of
                        the site)
                    </p>

                    <img src="/img/astro-zen-x.png" style={{ width: 180, transform: "translate(380px,20px)" }} />
                </div>
            </div>
        )
    }

    return (
        <div className="x-task-master">
            <div className="x-dna-filters x-tm-filters">
                <Scrollbars>
                    <label className="top">Find</label>
                    <input
                        type="text"
                        id="23oi4u89"
                        className="x-qfs-tm"
                        placeholder="Search action items..."
                        onChange={(e) => {
                            e.persist()
                            clearTimeout(to.current)

                            document.getElementById("23oi4u90").value = ""

                            to.current = setTimeout(() => {
                                rowBufferRef.current = []

                                nextIndexRef.current = null
                                hasMore.current = true
                                setSearch(e.target.value)
                                setTotalTasks(0)
                            }, 600)
                        }}
                    />
                    <input
                        id="23oi4u90"
                        type="text"
                        className="x-qfs-tm code-s"
                        placeholder="Task code..."
                        onChange={(e) => {
                            e.persist()

                            clearTimeout(to.current)
                            if (e.target.value?.length === 0) {
                                setSearch(undefined)

                                rowBufferRef.current = []

                                nextIndexRef.current = null
                                hasMore.current = true

                                setTotalTasks(0)

                                resetInfiniteGrid()

                                return
                            }

                            document.getElementById("23oi4u89").value = ""

                            if (e.target.value?.length < 4) {
                                return
                            }

                            to.current = setTimeout(() => {
                                rowBufferRef.current = []

                                nextIndexRef.current = null
                                hasMore.current = true
                                setSearch({ taskCode: e.target.value })
                                setTotalTasks(0)
                            }, 600)
                        }}
                    />

                    <label>By person</label>
                    {!people?.length && (
                        <Skeleton
                            width={230}
                            height={38}
                            style={{ marginTop: 10, marginBottom: 10, borderRadius: 3 }}
                        />
                    )}
                    {people?.length > 0 && (
                        <SearchDropDown
                            data={[
                                { personName: "My action items", _id: "mine" },
                                { personName: "My pinned items", _id: "mine-pinned" },
                                { personName: "Unassigned tasks", _id: "unassigned" },
                                ...sortAlpha(people.map((p) => ({ ...p, personName: getPersonName(p) }))),
                            ]}
                            value={
                                !filters.personRefId
                                    ? ""
                                    : filters.personRefId === "mine-pinned"
                                      ? "Pinned tasks"
                                      : filters.personRefId === app.state.person._id
                                        ? "My action items"
                                        : filters.personRefId === "unassigned"
                                          ? "Unassigned open tasks"
                                          : getPersonName(peopleHash[filters.personRefId])
                            }
                            wrapperClassName={cx({ "x-f-red": filters.personRefId })}
                            labelKey={"personName"}
                            isItemSelectable={(item) => {
                                return !item.data.header
                            }}
                            placeHolder={"Everyone's tasks..."}
                            showClearIcon={true}
                            noAlpha={true}
                            onSelect={(label, obj) => {
                                if (!obj) return

                                let value

                                if (obj?._id === "mine" || obj?._id === "mine-pinned") {
                                    if (obj?._id === "mine-pinned") {
                                        value = "mine-pinned"
                                    } else {
                                        value = app.state.person._id
                                    }
                                } else if (obj?._id === "unassigned") {
                                    value = "unassigned"
                                } else {
                                    value = getRefId(obj)
                                }

                                if (value === "mine-pinned") {
                                    setFilters({ personRefId: value })
                                } else {
                                    updateFilters({ personRefId: value })
                                }
                            }}
                            onClear={() => {
                                updateFilters({ personRefId: null })
                            }}
                        />
                    )}

                    <label>Task status</label>

                    <SearchDropDown
                        data={statusArray}
                        noAlpha
                        value={filters.status ? statusArray.find((d) => d.id === filters.status)?.label : ""}
                        wrapperClassName={cx({ "x-f-orange": filters.status })}
                        placeHolder="Select a status..."
                        labelKey="label"
                        onSelect={(label, obj) => {
                            updateFilters({ status: obj.id })
                        }}
                        selectOnBlur={false}
                        showClearIcon={true}
                        onClear={() => {
                            updateFilters({ status: null })
                        }}
                    />

                    <label>Project status</label>
                    <SearchDropDown
                        data={missionStatusArray}
                        wrapperClassName={cx({ "x-f-orange": filters.missionStatus })}
                        placeHolder="Project status..."
                        labelKey="label"
                        value={
                            filters.missionStatus
                                ? missionStatusArray.find((a) => a.id === filters.missionStatus)?.label
                                : ""
                        }
                        onSelect={(label, obj) => {
                            updateFilters({ missionStatus: obj?.id || null })
                        }}
                        selectOnBlur={false}
                        showClearIcon={true}
                        onClear={() => {
                            updateFilters({ missionStatus: null })
                        }}
                    />

                    <label>Specific mission</label>

                    <MissionSearch
                        app={app}
                        width={234}
                        portal={true}
                        menuWidth={300}
                        selectedId={filters.missionId}
                        onSelect={(m) => {
                            updateFilters({ missionId: m?._id || null })
                        }}
                    />

                    <label>Default status</label>

                    <CheckBoxes
                        radio
                        controlled
                        data={[
                            {
                                label: "All activities",
                                checked: !filters.forceTaskStatus,
                            },
                            {
                                label: "Only open",
                                id: "open",
                                checked: filters.forceTaskStatus === "open",
                            },
                            {
                                label: "Only completed",
                                id: "done",
                                checked: filters.forceTaskStatus === "done",
                            },
                        ]}
                        onChange={(a, b, c, obj) => {
                            if (!c) {
                                updateFilters({
                                    forceTaskStatus: null,
                                })
                            } else {
                                updateFilters({
                                    forceTaskStatus: obj.id,
                                })
                            }
                        }}
                    />
                </Scrollbars>
                <div className="x-action-bg"></div>
            </div>
            <div className="w-full x-tm-main-body">
                <div
                    className={cx("x-tm-header", {
                        loading: loading,
                    })}
                >
                    <h2>
                        {numeral(totalTasks).format("0,0")}{" "}
                        <span>matching {`action item${totalTasks === 1 ? "" : "s"}`}</span>
                    </h2>
                </div>

                {loading && (
                    <div className={"x-tm-loading-bar"}>
                        <BarLoader color={"orange"} loading={true} height={6} width={680} speedMultiplier={0.5} />
                    </div>
                )}

                <div className={"ag-theme-alpine dna-ag-grid x-t-grid"}>
                    <AgGridReact
                        ref={gridRef}
                        columnDefs={columnDefs}
                        getRowId={getRowId}
                        suppressContextMenu={true}
                        headerHeight={0}
                        animateRows={true}
                        defaultColDef={defaultColDef}
                        pinnedTopRowData={pinnedTopRowData}
                        onGridReady={(params) => params.api.onFilterChanged()}
                        onCellClicked={onCellClicked}
                        datasource={dataSource}
                        rowHeight={115}
                        rowModelType="infinite"
                        cacheOverflowSize={2}
                        maxConcurrentDatasourceRequests={1}
                        infiniteInitialRowCount={0}
                        maxBlocksInCache={10}
                        cacheBlockSize={50} //
                    />
                </div>
            </div>
        </div>
    )
}

const TaskCell = (params) => {
    useEffect(() => {
        // Every change in the notice to this row's task, merged oldest first
        const objs = missionChangeEntries(params.app.state.missionChange)
            .filter((e) => e.obj && e.obj._id === params.data._id)
            .map((e) => e.obj)

        if (!objs.length) return

        const index = params.rowBufferRef.current.findIndex((r) => r._id === params.data._id)

        if (index === -1) return

        const obj = Object.assign({}, ...objs)

        params.rowBufferRef.current[index] = {
            ...params.rowBufferRef.current[index],
            ...obj,
        }

        // Tell AG Grid to redraw this row
        params.node.setData({
            ...params.node.data,
            ...obj,
        })
    }, [params.app.state.missionChange?.timestamp])

    const ai = params.data

    useEffect(() => {
        if (!params.node.data.missionData) {
            const gm = async () => {
                const m = await getMissionBasicDetails({ missionId: ai.missionId })

                params.node.setData({
                    ...params.node.data,
                    missionData: m,
                })
            }

            gm()
        }
    }, [params.node.data.missionData])

    const dueDate = findAiEndDate(ai)

    const { app, setContext } = params

    const mission = params.node.data?.missionData

    const pct = useMemo(() => {
        if (ai.status === "done") {
            return 100
        }
        if (!ai.missionObj) return 0
        if (ai.missionObj.projectType === "mx-gantt") {
            return ai.percentComplete
        } else {
            const progress = ai.checklist?.filter((c) => c.done)?.length || 0
            return (progress / ai.checklist?.length || 0) * 100
        }
    }, [ai.missionObj, ai.checklist])

    if (params.data.pinnedMessage) {
        return (
            <div className="dna-flex">
                <img src="/img/mAX.png" style={{ width: 50, marginRight: 20 }} />
                <p>
                    Hi {app.state.person.firstName}. New{" "}
                    <span onClick={() => setContext("workAI")} className="x-link active">
                        notifications
                    </span>{" "}
                    available.
                </p>
            </div>
        )
    }

    if (!mission) {
        return null
    }

    const org = params.orgRef.current[ai.org]

    const orgPeople = makeRefHash(org?.people || [])

    const aiPeople = (ai?.people || []).map((ap) => orgPeople[ap]).filter((p) => !!p)

    if (!ai) {
        return <></>
    }

    const overdue = mission ? isOverdue(ai, mission) : null
    let status = " "

    if (ai.status === "blocked") {
        status = <div className="dna-pill-box red-pill">Blocked</div>
    } else if (overdue) {
        status = <div className="dna-pill-box orange-pill">Overdue</div>
    } else if (ai.status === "done") {
        status = <div className="dna-pill-box green-pill">Done</div>
    } else if (ai.week || mission.projectType === "mx-gantt") {
        status = <div className="dna-pill-box blue-pill">In progress</div>
    } else {
        status = <div className="dna-pill-box">Unplanned</div>
    }

    const lastSeenObj = (ai.seen || []).sort((a, b) => b?.when - a?.when)[0]
    const lastSeenBy = orgPeople[lastSeenObj?.by]
    const lastSeenWhen = toZonedTime(lastSeenObj?.when)

    return (
        <div className="dna-flex">
            <div className="x-tm-ai-left">
                <div className="x-tm-ai-title">
                    <b className="x-clamp-2">
                        {getAiCode(ai)} {ai.title || "No title specified..."}
                    </b>
                </div>
                <div className={cx("dna-progress-bar-x", { blue: pct === 100 })}>
                    <div style={{ width: pct + "%" }}></div>
                </div>
                <div className="dna-center-flex">
                    <span className={cx(getMissionStatusCls(mission))}>{getMissionStatus(mission, true)}</span>

                    <div
                        style={{ maxWidth: 380 }}
                        className="dna-smaller-text x-clamp-1 x-link x-miss-title-tm"
                        onClick={(e) => {
                            e.stopPropagation()
                            addParam("mission", mission?._id)
                        }}
                    >
                        {mission.projectCode} {mission.projectCode && "-"} {mission?.title || ""}
                    </div>
                </div>

                <Hive
                    style={{ marginTop: 10 }}
                    round
                    ai={ai}
                    mission={mission}
                    people={aiPeople}
                    width={26}
                    orgData={org}
                    maxLength={8}
                    app={params.app}
                />
            </div>

            <div className="x-tm-ai-details">
                {status}
                {dueDate > 0 && (
                    <p className="x-tm-dd">
                        {" "}
                        {ai.endDate ? "Due date:" : "For:"} {formatX(dueDate, true, true)}
                    </p>
                )}
                {!ai.seen?.length ? (
                    <p>Nobody's viewed this yet</p>
                ) : lastSeenWhen && lastSeenBy ? (
                    <p>
                        Last viewed {formatDistanceToNowStrict(lastSeenWhen) + " ago"} by {getPersonName(lastSeenBy)}
                    </p>
                ) : (
                    ""
                )}
            </div>
        </div>
    )
}

TaskMaster.displayName = "TaskMaster"

export default TaskMaster
